import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/web.dom-collections.for-each.js";
var fileDownload = require("js-file-download");
import axios from "axios";
import { request } from "@/js/http/http_request";
import { REGULAR_BOTTLING, listUserGroups, creditNoteItem, listCurrencies, listWineTypes, orderStatus, creditNote } from "@/js/lists.ts";
import { getFullNameUser } from "@/js/user/user.js";
import { getSymbolCurrency, formatPrice, roundToTwoDigit, displayPrice, getCurrentRate } from "@/js/currency/currencies.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { getUnitPriceCurrencyForItem, getNbRegularBottlePerBottlingForLogisticCost } from "@/js/order/order.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import WineNaming from "@/components/products/WineNaming.vue";
export default {
  name: "CreditNoteModal",
  props: {
    order: Object,
    withOrder: {
      type: Boolean,
      default: true
    },
    creditNoteId: {
      type: Number,
      default: null
    },
    createOrder: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal,
    WineNaming: WineNaming
  },
  data: function data(_this) {
    return {
      shown: false,
      options: {
        color: "primary",
        width: 600,
        zIndex: 2000
      },
      isSaving: false,
      isTargetImporter: false,
      creditNote: {
        id: null,
        status: creditNote.status.DRAFT,
        fromOrderId: null,
        createOrder: _this.createOrder,
        userId: null,
        importerId: null,
        initialCurrency: "EUR",
        initialCurrencyRate: 1.0,
        initialVatRate: null,
        totalAmountEuro: 0.0,
        totalAmountCurrency: 0.0,
        totalAmountExVatEuro: 0.0,
        totalAmountExVatCurrency: 0.0,
        isAppliedInFullOnSourceOrder: false,
        isReturnedToInventory: false,
        extraDescription: "",
        comment: "",
        itemDescription: "",
        items: []
      },
      isIssued: false,
      itemShipping: {
        isIncluded: false,
        type: creditNoteItem.type.SHIPPING,
        description: "Shipping",
        quantity: 1,
        unitPrice: 0,
        unitPriceExVat: 0,
        unitPriceCurrency: 0,
        unitPriceExVatCurrency: 0,
        amount: 0,
        amountExVat: 0,
        amountCurrency: 0,
        amountExVatCurrency: 0
      },
      isItemShippingUpdated: false,
      isShippingAlreadyIncluded: false,
      labelShipping: "",
      remainingShippingCurrency: 0,
      remainingAmountCurrency: 0,
      searchCreditNoteCriterias: {
        fromOrderId: "",
        includeDeleted: false
      },
      orderItems: [],
      searchOrderItem: null,
      orderItemsAddables: [],
      quantityToggleKey: false,
      searchUserCriterias: {
        label: null,
        isAdminNotConsultant: false,
        include_archive: true
      },
      users: null,
      currencyUsers: [],
      userSelected: null,
      importers: null,
      importerSelected: null,
      exportingPdf: {
        isPending: false,
        cancellationToken: null
      },
      managedExceptions: {
        warning: {
          credit_note_already_deleted: "The credit note is already deleted.",
          credit_note_already_closed: "The credit note is already closed.",
          credit_note_already_canceled: "The credit note is already canceled.",
          credit_note_already_used: "Credit note is already used.",
          credit_note_in_used: "The credit note is in used.",
          credit_note_use_remaining_amount_invalid: "The remaining amount to refund is less than the desired amount.",
          credit_note_use_blocked_by_order: "To refund the desired amount, you must remove some uses on the associated order(s)."
        }
      },
      ERROR_DATA: ERROR_DATA,
      rules: formRules,
      listCurrencies: listCurrencies,
      orderStatus: orderStatus
    };
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.$EventBus.$emit("loading", true);
            _this = _this2;
            if (!_this2.withOrder) {
              _this2.users = [];
              _this2.searchUsers("");
              _this2.importers = [];
              _this2.fetchImporters();
            }
            if (!_this2.creditNoteId) {
              _context.next = 8;
              break;
            }
            _context.next = 6;
            return _this2.fetchCreditNote(_this2.creditNoteId);
          case 6:
            _context.next = 9;
            break;
          case 8:
            if (_this2.withOrder && _this2.order && !_this2.isPaymentSucceeded) {
              _this2.creditNote.isAppliedInFullOnSourceOrder = true;
            }
          case 9:
            if (!_this2.withOrder) {
              _context.next = 22;
              break;
            }
            _this2.creditNote.fromOrderId = _this2.order.id_order;
            _this2.creditNote.totalAmountCurrency = 0;
            _this2.searchCreditNoteCriterias.fromOrderId = _this2.order.id_order;
            _this2.remainingAmountCurrency = _this2.order.total_amount_currency;
            _this2.remainingShippingCurrency = _this2.order.amount_shipping_currency;
            _this2.order.items.map(function (item) {
              item.totalRemainingQuantity = item.quantity;
              item.creditNoteQuantity = item.quantity;
              item.unitPriceExVat = roundToTwoDigit(item.amount_ex_vat / item.quantity);
              item.unitPriceExVatCurrency = roundToTwoDigit(item.amount_ex_vat_currency / item.quantity);
              item.isSelected = _this.creditNoteId ? false : true;
              return item;
            });
            _context.next = 18;
            return _this2.fetchAssociatedCreditNotes();
          case 18:
            if (_this2.creditNoteId) {
              if (_this2.creditNote.items) {
                _this.creditNote.items.filter(function (x) {
                  return x.type === creditNoteItem.type.SHIPPING;
                }).forEach(function (cnItem) {
                  _this.creditNote.totalAmountCurrency = roundToTwoDigit(_this.creditNote.totalAmountCurrency + cnItem.amountCurrency);
                  _this.itemShipping = _objectSpread(_objectSpread({}, cnItem), {}, {
                    isIncluded: true
                  });
                });
                _this.creditNote.items = _this.creditNote.items.filter(function (x) {
                  return x.type === creditNoteItem.type.PRODUCT;
                });
                _this2.order.items.map(function (orderItem) {
                  _this.creditNote.items.filter(function (x) {
                    return x.wineId === orderItem.id_wine;
                  }).map(function (cnItem) {
                    cnItem.orderQuantity = orderItem.totalRemainingQuantity;
                    cnItem.inboundQuantityAvailable = orderItem.inboundQuantityAvailable;
                    orderItem.creditNoteQuantity -= cnItem.quantity;
                    orderItem.isSelected = true;
                    _this.creditNote.totalAmountCurrency = roundToTwoDigit(_this.creditNote.totalAmountCurrency + cnItem.amountCurrency);
                    return cnItem;
                  });
                  return orderItem;
                });
              }
            }
            if (_this2.withOrder) {
              _this2.orderItems = _this2.order.items.filter(function (i) {
                return i.totalRemainingQuantity >= 0;
              });
              _this2.orderItems.forEach(function (x) {
                if (x.creditNoteQuantity > 0 && !_this.creditNoteId) {
                  _this2.creditNote.items.push({
                    type: creditNoteItem.type.PRODUCT,
                    orderItemId: x.id_item,
                    wine: x.wine,
                    wineId: x.id_wine,
                    currency: x.currency,
                    unitPrice: x.unit_price,
                    unitPriceExVat: x.unitPriceExVat,
                    unitPriceCurrency: x.unit_price_currency,
                    unitPriceExVatCurrency: x.unitPriceExVatCurrency,
                    quantity: x.totalRemainingQuantity,
                    orderQuantity: x.totalRemainingQuantity,
                    inboundQuantityAvailable: x.inboundQuantityAvailable,
                    amount: x.unit_price * x.totalRemainingQuantity,
                    amountExVat: x.unitPriceExVat * x.totalRemainingQuantity,
                    amountCurrency: x.unit_price_currency * x.totalRemainingQuantity,
                    amountExVatCurrency: x.unitPriceExVatCurrency * x.totalRemainingQuantity,
                    amountTaxes: x.amount_taxes,
                    amountTaxesCurrency: x.amount_taxes_currency,
                    unitDefaultShippingCurrencyIncluded: _this2.order.isDefaultShippingIncludedInItems ? x.unitDefaultShippingCurrency : 0
                  });
                  if (x.totalRemainingQuantity > 0) {
                    _this2.creditNote.totalAmountExVatEuro = roundToTwoDigit(_this2.creditNote.totalAmountExVatEuro + x.unitPriceExVat * x.totalRemainingQuantity);
                    _this2.creditNote.totalAmountCurrency = roundToTwoDigit(_this2.creditNote.totalAmountCurrency + x.unit_price_currency * x.totalRemainingQuantity);
                  }
                }
                _this2.orderItemsAddables.push({
                  orderItemId: x.id_item,
                  display_name: x.unitPriceIncludeDefaultShippingCurrency + " " + getSymbolCurrency(x.currency) + "/b - " + x.wine.display_name + " - " + x.wine.sku
                });
              });
            }
            if (!_this2.creditNoteId) {
              if (!_this2.isShippingAlreadyIncluded && _this2.order.amount_shipping_currency > 0) {
                _this2.itemShipping.isIncluded = true;
                _this2.calculShipping();
                _this2.creditNote.totalAmountExVatEuro = roundToTwoDigit(_this2.creditNote.totalAmountExVatEuro + _this2.itemShipping.amountExVat);
                _this2.creditNote.totalAmountCurrency = roundToTwoDigit(_this2.creditNote.totalAmountCurrency + _this2.itemShipping.amountCurrency);
              }
            }
            _this2.calculShipping();
          case 22:
            _this2.$EventBus.$emit("loading", false);
          case 23:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  computed: {
    isConcernedByVat: function isConcernedByVat() {
      var _this$order;
      return ((_this$order = this.order) === null || _this$order === void 0 ? void 0 : _this$order.amount_vat) > 0;
    },
    getCurrencies: function getCurrencies() {
      return listCurrencies.filter(function (x) {
        return x.implanted_market;
      });
    },
    orderListItems: function orderListItems() {
      return this.orderItems;
    },
    creditNoteListItems: function creditNoteListItems() {
      return this.creditNote.items.filter(function (x) {
        return x.type !== creditNoteItem.type.SHIPPING && x.quantity >= 0;
      });
    },
    getOrderNbItems: function getOrderNbItems() {
      return this.order.items.reduce(function (acc, x) {
        return acc + x.quantity;
      }, 0);
    },
    getCreditNoteNbItems: function getCreditNoteNbItems() {
      return this.creditNote.items.reduce(function (acc, x) {
        return x.type !== creditNoteItem.type.SHIPPING ? acc + parseInt(x.quantity) : acc;
      }, 0);
    },
    getTotalAmount: function getTotalAmount() {
      return formatPrice(this.creditNote.totalAmountCurrency);
    },
    getRemainingAmount: function getRemainingAmount() {
      return formatPrice(this.remainingAmountCurrency - roundToTwoDigit(this.creditNote.totalAmountCurrency));
    },
    disableRemoveAll: function disableRemoveAll() {
      return this.creditNote.items.length === 0;
    },
    isInvalidForm: function isInvalidForm() {
      var _this3 = this;
      var nullishPredicate = function nullishPredicate(x) {
        return !x.items.length && (_this3.itemShipping.amountCurrency <= 0 || _this3.itemShipping.amountCurrency > _this3.remainingShippingCurrency);
      };
      if (nullishPredicate(this.creditNote)) return true;
      return false;
    },
    selectCurrency: {
      get: function get() {
        return this.creditNote.initialCurrency;
      },
      set: function set(newValue) {
        var _this4 = this;
        return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _this4.creditNote.initialCurrency = newValue;
                _context2.next = 3;
                return _this4.getCurrentRate(_this4.creditNote.initialCurrency);
              case 3:
                _this4.creditNote.initialCurrencyRate = _context2.sent;
                _this4.calculAmounts();
              case 5:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }))();
      }
    },
    isIncludeVat: {
      get: function get() {
        return this.creditNote.initialVatRate;
      },
      set: function set(newValue) {
        if (newValue) {
          this.creditNote.initialVatRate = 1.2;
        } else {
          this.creditNote.initialVatRate = null;
        }
        this.calculAmounts();
      }
    },
    changeVat: {
      get: function get() {
        return this.creditNote.initialVatRate ? parseFloat(((this.creditNote.initialVatRate - 1) * 100).toFixed(1)) : null;
      },
      set: function set(newValue) {
        if (newValue) {
          this.creditNote.initialVatRate = 1 + newValue / 100;
        }
        this.calculAmounts();
      }
    },
    totalAmountExVatCurrency: {
      get: function get() {
        return this.creditNote.totalAmountExVatCurrency;
      },
      set: function set(newValue) {
        this.creditNote.totalAmountExVatEuro = roundToTwoDigit(newValue / this.creditNote.initialCurrencyRate);
        if (this.creditNote.initialVatRate) {
          this.creditNote.totalAmountEuro = roundToTwoDigit(this.creditNote.totalAmountExVatEuro * this.creditNote.initialVatRate);
          this.creditNote.totalAmountCurrency = roundToTwoDigit(this.creditNote.totalAmountEuro * this.creditNote.initialCurrencyRate);
        }
      }
    },
    totalAmountExVatEuro: {
      get: function get() {
        return this.creditNote.totalAmountExVatEuro;
      },
      set: function set(newValue) {
        this.creditNote.totalAmountExVatEuro = newValue;
        this.calculAmounts();
      }
    },
    totalAmountCurrency: {
      get: function get() {
        return this.creditNote.totalAmountCurrency;
      },
      set: function set(newValue) {
        this.creditNote.totalAmountExVatEuro = roundToTwoDigit(newValue / this.creditNote.initialVatRate / this.creditNote.initialCurrencyRate);
        this.creditNote.totalAmountEuro = roundToTwoDigit(this.creditNote.totalAmountExVatEuro * this.creditNote.initialVatRate);
        this.creditNote.totalAmountExVatCurrency = roundToTwoDigit(this.creditNote.totalAmountExVatEuro * this.creditNote.initialCurrencyRate);
      }
    },
    totalAmountEuro: {
      get: function get() {
        return this.creditNote.totalAmountEuro;
      },
      set: function set(newValue) {
        this.creditNote.totalAmountExVatEuro = roundToTwoDigit(newValue / this.creditNote.initialVatRate);
        this.creditNote.totalAmountExVatCurrency = roundToTwoDigit(this.creditNote.totalAmountExVatEuro * this.creditNote.initialCurrencyRate);
        this.creditNote.totalAmountCurrency = roundToTwoDigit(this.creditNote.totalAmountExVatCurrency * this.creditNote.initialVatRate);
      }
    },
    includedShippingCurrencyInCnItems: function includedShippingCurrencyInCnItems() {
      return this.creditNoteListItems.reduce(function (acc, item) {
        return acc + roundToTwoDigit(item.quantity * item.unitDefaultShippingCurrencyIncluded);
      }, 0);
    },
    itemShippingAmountCurrencyMinusShippingIncluded: function itemShippingAmountCurrencyMinusShippingIncluded() {
      return formatPrice(this.itemShipping.amountCurrency - this.includedShippingCurrencyInCnItems);
    },
    orderIsPricePostedWithProperShipping: function orderIsPricePostedWithProperShipping() {
      var _this$order2, _this$order3;
      return this.withOrder && ((_this$order2 = this.order) === null || _this$order2 === void 0 || (_this$order2 = _this$order2.pricePostingUsaPro) === null || _this$order2 === void 0 ? void 0 : _this$order2.id) > 0 && !((_this$order3 = this.order) !== null && _this$order3 !== void 0 && _this$order3.shippingHasBeenCalculatedByMl);
    },
    getUnitPriceShippingCurrencyNotIncluded: function getUnitPriceShippingCurrencyNotIncluded() {
      var _this$order4;
      if (this.withOrder && ((_this$order4 = this.order) === null || _this$order4 === void 0 ? void 0 : _this$order4.amountShippingNotIncludedInItemsCurrency) > 0) {
        var _this$order5;
        return ((_this$order5 = this.order) === null || _this$order5 === void 0 ? void 0 : _this$order5.amountShippingNotIncludedInItemsCurrency) / this.getOrderNbRegularBottlesForShipping(this.order.items);
      } else {
        return 0;
      }
    },
    isPaymentSucceeded: function isPaymentSucceeded() {
      var _this$order$payments$, _this$order6, _this$order7;
      var amountOfPayments = (_this$order$payments$ = (_this$order6 = this.order) === null || _this$order6 === void 0 || (_this$order6 = _this$order6.payments) === null || _this$order6 === void 0 ? void 0 : _this$order6.reduce(function (acc, payment) {
        return roundToTwoDigit(acc + payment.amount);
      }, 0)) !== null && _this$order$payments$ !== void 0 ? _this$order$payments$ : 0;
      return amountOfPayments >= ((_this$order7 = this.order) === null || _this$order7 === void 0 ? void 0 : _this$order7.total_amount_currency);
    },
    isWithoutOrderInvalidForm: function isWithoutOrderInvalidForm() {
      var nullishPredicate = function nullishPredicate(x) {
        return !x.itemDescription || x.totalAmountExVatCurrency <= 0 || !x.userId && !x.importerId || !x.initialCurrency;
      };
      if (nullishPredicate(this.creditNote)) return true;
      return false;
    }
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed");
    },
    closeAndReload: function closeAndReload() {
      this.shown = false;
      this.$emit("closedandreloaded");
    },
    validateAndAutoApply: function validateAndAutoApply() {
      this.shown = false;
      this.$emit("validateandautoapply");
    },
    fetchCreditNote: function fetchCreditNote(id) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _response$data$value$, _response$data$value$2, _this5$creditNote$fro;
        var _this, response, customItems;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this = _this5;
              _context3.next = 3;
              return request("/v1/credit-notes/".concat(id), "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load current credit note.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              response = _context3.sent;
              _this5.creditNote = _objectSpread(_objectSpread({}, response.data.value), {}, {
                userId: (_response$data$value$ = response.data.value.user) === null || _response$data$value$ === void 0 ? void 0 : _response$data$value$.idUser,
                importerId: (_response$data$value$2 = response.data.value.importer) === null || _response$data$value$2 === void 0 ? void 0 : _response$data$value$2.id
              });
              _this5.isTargetImporter = !!_this5.creditNote.importerId;
              if ((_this5$creditNote$fro = _this5.creditNote.fromOrder) !== null && _this5$creditNote$fro !== void 0 && _this5$creditNote$fro.id) {
                _context3.next = 14;
                break;
              }
              customItems = _this5.creditNote.items.filter(function (x) {
                return x.type === creditNoteItem.type.CUSTOM;
              });
              if (customItems.length === 1) {
                _this5.creditNote.itemDescription = customItems[0].description;
                _this5.creditNote.items = [];
              }
              if (_this5.creditNote.userId) {
                _this5.userSelected = _this5.creditNote.userId;
              } else if (_this5.creditNote.importerId) {
                _this5.importerSelected = _this5.creditNote.importerId;
              }
              _context3.next = 12;
              return _this5.getCurrentRate(_this5.creditNote.initialCurrency);
            case 12:
              _this5.creditNote.initialCurrencyRate = _context3.sent;
              _this5.calculAmounts();
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    fetchAssociatedCreditNotes: function fetchAssociatedCreditNotes() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, items, totalAmountShipping;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this6;
              items = [];
              totalAmountShipping = 0;
              _context4.next = 5;
              return request("/v1/credit-notes/all", "post", _this6.searchCreditNoteCriterias, true, "api").then(function (response) {
                response.data.value.items.forEach(function (creditNote) {
                  if (creditNote.items && (!_this.creditNoteId || creditNote.id !== _this.creditNoteId)) {
                    creditNote.items.forEach(function (x) {
                      if (x.type === creditNoteItem.type.SHIPPING) {
                        totalAmountShipping = roundToTwoDigit(totalAmountShipping + x.amountCurrency);
                        _this.remainingAmountCurrency = roundToTwoDigit(_this.remainingAmountCurrency - x.amountCurrency);
                        _this.remainingShippingCurrency = roundToTwoDigit(_this.remainingShippingCurrency - x.amountCurrency);
                      }
                      if (x.type === creditNoteItem.type.PRODUCT) {
                        items.push(_objectSpread({}, x));
                      }
                    });
                  }
                });
              }).catch(function (e) {
                _this.$toasted.show("Unable to load associated credit notes.", {
                  type: "error"
                });
                _this.$EventBus.$emit("loading", false);
                throw e;
              });
            case 5:
              if (totalAmountShipping > 0 && totalAmountShipping >= _this6.order.amount_shipping_currency) {
                _this6.isShippingAlreadyIncluded = true;
              }
              if (items) {
                _this6.order.items.map(function (orderItem) {
                  var creditNotesItems = items.filter(function (x) {
                    return x.wineId == orderItem.id_wine;
                  });
                  if (creditNotesItems.length > 0) {
                    creditNotesItems.forEach(function (cnItem) {
                      _this.remainingAmountCurrency = roundToTwoDigit(_this.remainingAmountCurrency - cnItem.amountCurrency);
                      orderItem.totalRemainingQuantity -= cnItem.quantity;
                      orderItem.creditNoteQuantity -= cnItem.quantity;
                    });
                  }
                  if (orderItem.totalRemainingQuantity === 0) {
                    orderItem.isSelected = true;
                  }
                  return orderItem;
                });
              }
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    selectOrderItems: function selectOrderItems(item) {
      if (item) {
        this.orderItems = this.order.items.filter(function (i) {
          return i.id_item == item.orderItemId;
        });
      } else {
        this.orderItems = this.order.items.filter(function (i) {
          return i.totalRemainingQuantity >= 0;
        });
      }
    },
    productDetails: function productDetails(wine) {
      var detailsRoute = wine.type == listWineTypes.find(function (x) {
        return x.name === "Spirit";
      }).id ? "adminSpiritsDetails" : "adminWineDetails";
      return {
        name: detailsRoute,
        params: {
          id: wine.id_wine
        }
      };
    },
    getOrderRemainingQuantity: function getOrderRemainingQuantity() {
      var _this7 = this;
      var total = 0;
      this.order.items.forEach(function (orderItem) {
        total += _this7.getRemainingQuantity(orderItem.id_item, orderItem.totalRemainingQuantity);
      });
      return total;
    },
    getRemainingQuantity: function getRemainingQuantity(orderItemId, total) {
      var item = this.creditNote.items.filter(function (x) {
        return x.orderItemId == orderItemId;
      });
      item.forEach(function (x) {
        total -= x.quantity;
      });
      return total;
    },
    calculate: function calculate() {
      var _this8 = this;
      var recalculeShipping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.creditNote.totalAmountExVatEuro = 0;
      this.creditNote.totalAmountCurrency = 0;
      this.creditNote.items.forEach(function (x) {
        _this8.creditNote.totalAmountExVatEuro += x.amountExVat;
        _this8.creditNote.totalAmountCurrency += x.amountCurrency;
      });
      if (recalculeShipping) {
        this.calculShipping();
      }
      if (this.itemShipping.isIncluded) {
        this.creditNote.totalAmountExVatEuro += this.itemShipping.amountExVat;
        this.creditNote.totalAmountCurrency += this.itemShipping.amountCurrency;
      }
    },
    calculShipping: function calculShipping() {
      var nbOrderRegularItems = 0;
      var nbCreditNoteRegularItems = 0;
      if (this.order.shippingHasBeenCalculatedByMl) {
        this.order.items.forEach(function (x) {
          nbOrderRegularItems += x.quantity * x.wine.bottling / REGULAR_BOTTLING;
        });
        this.creditNote.items.forEach(function (x) {
          if (x.type !== creditNoteItem.type.SHIPPING) {
            nbCreditNoteRegularItems += parseInt(x.quantity) * x.wine.bottling / REGULAR_BOTTLING;
          }
        });
      } else {
        nbOrderRegularItems = this.getOrderNbRegularBottlesForShipping(this.order.items);
        nbCreditNoteRegularItems = this.getCreditNoteNbRegularBottlesForShipping(this.creditNote.items);
      }
      if (this.order.amount_shipping_currency > 0 && nbCreditNoteRegularItems > 0) {
        this.itemShipping.unitPriceCurrency = roundToTwoDigit(this.order.amount_shipping_currency / nbOrderRegularItems * nbCreditNoteRegularItems);
        if (parseFloat(this.itemShipping.unitPriceCurrency) > roundToTwoDigit(this.remainingShippingCurrency)) {
          this.itemShipping.unitPriceCurrency = roundToTwoDigit(this.remainingShippingCurrency);
          var currencyRate = roundToTwoDigit(this.order.amountShippingExVatCurrency / this.order.amountShippingExVat);
          if (this.order.amount_vat_currency > 0) {
            var vatRate = roundToTwoDigit(this.order.total_amount_currency / this.order.amount_ex_vat_currency);
            this.itemShipping.unitPriceExVat = roundToTwoDigit(this.itemShipping.unitPriceCurrency / vatRate / currencyRate);
            this.itemShipping.unitPrice = roundToTwoDigit(this.itemShipping.unitPriceExVat * vatRate);
            this.itemShipping.unitPriceExVatCurrency = roundToTwoDigit(this.itemShipping.unitPriceCurrency / vatRate);
          } else {
            this.itemShipping.unitPriceExVat = roundToTwoDigit(this.itemShipping.unitPriceCurrency / currencyRate);
            this.itemShipping.unitPrice = this.itemShipping.unitPriceExVat;
            this.itemShipping.unitPriceExVatCurrency = this.itemShipping.unitPriceCurrency;
          }
        } else {
          this.itemShipping.unitPrice = roundToTwoDigit(this.order.amount_shipping / nbOrderRegularItems * nbCreditNoteRegularItems);
          this.itemShipping.unitPriceExVat = roundToTwoDigit(this.order.amountShippingExVat / nbOrderRegularItems * nbCreditNoteRegularItems);
          this.itemShipping.unitPriceExVatCurrency = roundToTwoDigit(this.order.amountShippingExVatCurrency / nbOrderRegularItems * nbCreditNoteRegularItems);
        }
      } else {
        this.itemShipping.unitPrice = 0;
        this.itemShipping.unitPriceExVat = 0;
        this.itemShipping.unitPriceCurrency = 0;
        this.itemShipping.unitPriceExVatCurrency = 0;
      }
      this.itemShipping.amount = this.itemShipping.unitPrice;
      this.itemShipping.amountCurrency = this.itemShipping.unitPriceCurrency;
      this.itemShipping.amountExVat = this.itemShipping.unitPriceExVat;
      this.itemShipping.amountExVatCurrency = this.itemShipping.unitPriceExVatCurrency;
      this.isItemShippingUpdated = true;
    },
    getOrderNbRegularBottlesForShipping: function getOrderNbRegularBottlesForShipping(orderItems) {
      var nbRegularItems = 0;
      orderItems.forEach(function (x) {
        nbRegularItems += x.quantity * getNbRegularBottlePerBottlingForLogisticCost(x.wine.bottling);
      });
      return nbRegularItems;
    },
    getCreditNoteNbRegularBottlesForShipping: function getCreditNoteNbRegularBottlesForShipping(creditNoteItems) {
      var nbRegularItems = 0;
      creditNoteItems.forEach(function (x) {
        if (x.type !== creditNoteItem.type.SHIPPING) {
          nbRegularItems += parseInt(x.quantity) * getNbRegularBottlePerBottlingForLogisticCost(x.wine.bottling);
        }
      });
      return nbRegularItems;
    },
    addAll: function addAll() {
      var _this9 = this;
      this.$EventBus.$emit("loading", true);
      this.creditNote.items = [];
      var orderItems = this.order.items.filter(function (i) {
        return i.quantity >= 0;
      });
      orderItems.forEach(function (x) {
        if (x.totalRemainingQuantity > 0) {
          var _this9$order;
          _this9.creditNote.items.push({
            type: creditNoteItem.type.PRODUCT,
            orderItemId: x.id_item,
            wine: x.wine,
            wineId: x.id_wine,
            currency: x.currency,
            unitPrice: x.unit_price,
            unitPriceExVat: x.unitPriceExVat,
            unitPriceCurrency: x.unit_price_currency,
            unitPriceExVatCurrency: x.unitPriceExVatCurrency,
            quantity: x.totalRemainingQuantity,
            orderQuantity: x.totalRemainingQuantity,
            inboundQuantityAvailable: x.inboundQuantityAvailable,
            amount: x.unit_price * x.totalRemainingQuantity,
            amountExVat: x.unitPriceExVat * x.totalRemainingQuantity,
            amountCurrency: x.unit_price_currency * x.totalRemainingQuantity,
            amountExVatCurrency: x.unitPriceExVatCurrency * x.totalRemainingQuantity,
            amountTaxes: x.amount_taxes,
            amountTaxesCurrency: x.amount_taxes_currency,
            unitDefaultShippingCurrencyIncluded: (_this9$order = _this9.order) !== null && _this9$order !== void 0 && _this9$order.isDefaultShippingIncludedInItems ? x.unitDefaultShippingCurrency : 0
          });
        }
      });
      this.calculate();
      this.order.items.map(function (item) {
        item.creditNoteQuantity = item.totalRemainingQuantity;
        item.isSelected = true;
        return item;
      });
      this.$EventBus.$emit("loading", false);
    },
    deleteAll: function deleteAll() {
      this.$EventBus.$emit("loading", true);
      this.creditNote.items = [];
      this.calculate();
      this.order.items.map(function (item) {
        if (item.totalRemainingQuantity > 0) {
          item.creditNoteQuantity = item.totalRemainingQuantity;
          item.isSelected = false;
        }
        return item;
      });
      this.$EventBus.$emit("loading", false);
    },
    addItem: function addItem(item, quantity) {
      this.$EventBus.$emit("loading", true);
      if (!this.creditNote.items.some(function (x) {
        return x.orderItemId === item.orderItemId;
      })) {
        var _this$order8;
        quantity = parseInt(quantity);
        if (quantity > item.totalRemainingQuantity) {
          quantity = item.totalRemainingQuantity;
        }
        if (quantity < 1) {
          quantity = 1;
        }
        this.creditNote.items.push({
          type: creditNoteItem.type.PRODUCT,
          orderItemId: item.id_item,
          wine: item.wine,
          wineId: item.id_wine,
          currency: item.currency,
          unitPrice: item.unit_price,
          unitPriceExVat: item.unitPriceExVat,
          unitPriceCurrency: item.unit_price_currency,
          unitPriceExVatCurrency: item.unitPriceExVatCurrency,
          quantity: quantity,
          orderQuantity: item.totalRemainingQuantity,
          inboundQuantityAvailable: item.inboundQuantityAvailable,
          amount: item.unit_price * quantity,
          amountExVat: item.unitPriceExVat * quantity,
          amountCurrency: item.unit_price_currency * quantity,
          amountExVatCurrency: item.unitPriceExVatCurrency * quantity,
          amountTaxes: item.amount_taxes,
          amountTaxesCurrency: item.amount_taxes_currency,
          unitDefaultShippingCurrencyIncluded: (_this$order8 = this.order) !== null && _this$order8 !== void 0 && _this$order8.isDefaultShippingIncludedInItems ? item.unitDefaultShippingCurrency : 0
        });
        this.order.items.filter(function (x) {
          return x.id_item == item.id_item;
        }).map(function (item) {
          item.creditNoteQuantity = quantity;
          item.isSelected = true;
          return item;
        });
      }
      this.calculate();
      this.$EventBus.$emit("loading", false);
    },
    deleteItem: function deleteItem(item) {
      this.$EventBus.$emit("loading", true);
      this.creditNote.items.splice(this.creditNote.items.indexOf(item), 1);
      this.order.items.filter(function (x) {
        return x.id_item == item.orderItemId;
      }).map(function (item) {
        item.creditNoteQuantity = item.totalRemainingQuantity;
        item.isSelected = false;
        return item;
      });
      this.calculate();
      this.$EventBus.$emit("loading", false);
    },
    changeQuantityCreditNote: function changeQuantityCreditNote(item, quantity) {
      this.$EventBus.$emit("loading", true);
      item.quantity = parseInt(quantity);
      if (item.quantity > item.orderQuantity) {
        item.quantity = item.orderQuantity;
      }
      if (item.quantity < 1) {
        item.quantity = 1;
      }
      item.amount = item.unitPrice * item.quantity;
      item.amountExVat = item.unitPriceExVat * item.quantity;
      item.amountCurrency = item.unitPriceCurrency * item.quantity;
      item.amountExVatCurrency = item.unitPriceExVatCurrency * item.quantity;
      this.calculate();
      this.$EventBus.$emit("loading", false);
    },
    calculAmounts: function calculAmounts() {
      if (this.creditNote.initialVatRate) {
        this.creditNote.totalAmountEuro = roundToTwoDigit(this.creditNote.totalAmountExVatEuro * this.creditNote.initialVatRate);
      } else {
        this.creditNote.totalAmountEuro = this.creditNote.totalAmountExVatEuro;
      }
      this.creditNote.totalAmountExVatCurrency = roundToTwoDigit(this.creditNote.totalAmountExVatEuro * this.creditNote.initialCurrencyRate);
      this.creditNote.totalAmountCurrency = roundToTwoDigit(this.creditNote.totalAmountEuro * this.creditNote.initialCurrencyRate);
    },
    changeUser: function changeUser(user) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!user) {
                _context5.next = 9;
                break;
              }
              _this10.creditNote.importerId = null;
              _this10.creditNote.userId = user.user_id;
              _this10.creditNote.initialCurrency = _this10.currencyUsers[user.user_id];
              _context5.next = 6;
              return _this10.getCurrentRate(_this10.creditNote.initialCurrency);
            case 6:
              _this10.creditNote.initialCurrencyRate = _context5.sent;
              _context5.next = 12;
              break;
            case 9:
              _this10.creditNote.userId = null;
              _this10.creditNote.initialCurrency = "EUR";
              _this10.creditNote.initialCurrencyRate = 1.0;
            case 12:
              _this10.calculAmounts();
            case 13:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    fullNameUser: function fullNameUser(user) {
      var userSuffix = "";
      if (user.archive) {
        userSuffix += " (archived)";
      } else if (!user.active) {
        userSuffix += " (inactive)";
      }
      return getFullNameUser(user) + " - " + user.delivery_country_iso_code + " " + listUserGroups.find(function (x) {
        return x.id == user.user_group.toUpperCase();
      }).name + " (" + user.login + ")" + userSuffix;
    },
    searchUsers: function searchUsers(value) {
      var _this = this;
      _this.searchUserCriterias.label = value;
      request("/v1/users", "post", _this.searchUserCriterias, true, "api").then(function (response) {
        response.data.users.forEach(function (user) {
          _this.currencyUsers[user.id_user] = user.default_currency;
          _this.users.push({
            user_id: user.id_user,
            active: user.active,
            archive: user.archive,
            full_name: _this.fullNameUser(user)
          });
        });
        _this.users.sort(function (a, b) {
          if (a.active && !b.active || !a.archive && b.archive) return -1;
          if (!a.active && b.active || a.archive && !b.archive) return 1;
          return a.full_name.localeCompare(b.full_name);
        });
      }).catch(function () {});
    },
    fetchImporters: function fetchImporters() {
      var _this = this;
      request("/v1/importers/all", "post", {}, true, "api").then(function (response) {
        _this.importers = _toConsumableArray(response.data.value.items);
        _this.importers.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      }).catch(function () {});
    },
    changeImporter: function changeImporter(importer) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (importer) {
                _this11.creditNote.userId = null;
                _this11.creditNote.importerId = importer.id;
              } else {
                _this11.creditNote.importerId = null;
              }
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    changeStatus: function changeStatus() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (_this12.isIssued) {
                _this12.creditNote.status = creditNote.status.VALIDATED;
              } else {
                _this12.creditNote.status = creditNote.status.DRAFT;
              }
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    saveCreditNote: function saveCreditNote() {
      var _arguments = arguments,
        _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var isValidated, _this, confirm, message, _this$userSelected, _this$importerSelecte;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              isValidated = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              _this13.isSaving = true;
              _this = _this13;
              confirm = true;
              if (!isValidated) {
                _context8.next = 10;
                break;
              }
              if (_this13.creditNote.isAppliedInFullOnSourceOrder && _this13.creditNote.isReturnedToInventory) {
                message = "The credit will no longer be editable and will be applied on the order. The products will be immediately repleted in the inventory. Are you sure you want to validate this credit note?";
              } else if (_this13.creditNote.isAppliedInFullOnSourceOrder && !_this13.creditNote.isReturnedToInventory) {
                message = "The credit will no longer be editable and will be applied on the order. The inventory will NOT be affected. Are you sure you want to validate this credit note?";
              } else if (!_this13.creditNote.isAppliedInFullOnSourceOrder && _this13.creditNote.isReturnedToInventory) {
                message = "The credit will no longer be editable and you could apply it on orders and/or refund it. The products will be immediately repleted in the inventory. Are you sure you want to validate this credit note?";
              } else {
                message = "The credit will no longer be editable and you could apply it on orders and/or refund it. The inventory will NOT be affected. Are you sure you want to validate this credit note?";
              }
              _context8.next = 8;
              return _this13.$refs.confirm.open("Validation", message, {
                width: 450,
                color: "red"
              });
            case 8:
              confirm = _context8.sent;
              if (confirm) {
                _this.creditNote.status = creditNote.status.VALIDATED;
                delete _this.creditNote["creationDate"];
              } else {
                _this13.isSaving = false;
              }
            case 10:
              if (!confirm) {
                _context8.next = 18;
                break;
              }
              if (!_this.withOrder) {
                _this.creditNote.userId = (_this$userSelected = _this.userSelected) === null || _this$userSelected === void 0 ? void 0 : _this$userSelected.user_id;
                _this.creditNote.importerId = (_this$importerSelecte = _this.importerSelected) === null || _this$importerSelecte === void 0 ? void 0 : _this$importerSelecte.id;
              }
              if (_this.itemShipping.isIncluded) {
                _this.creditNote.items.push(_this.itemShipping);
              }
              if (_this.creditNote.items.length === 0) {
                _this.creditNote.items.push({
                  type: creditNoteItem.type.CUSTOM,
                  description: _this.creditNote.itemDescription,
                  quantity: 1,
                  unitPriceCurrency: _this.creditNote.totalAmountCurrency,
                  unitPriceExVatCurrency: _this.creditNote.totalAmountExVatCurrency,
                  unitPrice: _this.creditNote.totalAmountEuro,
                  unitPriceExVat: _this.creditNote.totalAmountExVatEuro
                });
              }
              _context8.next = 16;
              return request("/v1/credit-notes", "post", _this.creditNote, true, "api", null).catch(function (e) {
                _this.isSaving = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save the credit note.", true);
                handleErrorData(_this, errorData);
                throw e;
              });
            case 16:
              _this13.isSaving = false;
              if (_this13.creditNote.isAppliedInFullOnSourceOrder) {
                _this13.validateAndAutoApply();
              } else {
                _this13.closeAndReload();
              }
            case 18:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    getPackingList: function getPackingList() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this$exportingPdf$ca;
        var _this, response, url;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this14.exportingPdf.isPending = true;
              _this = _this14;
              (_this$exportingPdf$ca = _this.exportingPdf.cancellationToken) === null || _this$exportingPdf$ca === void 0 || _this$exportingPdf$ca.cancel();
              _this.exportingPdf.cancellationToken = axios.CancelToken.source();
              _context10.next = 6;
              return request("/v1/credit-notes/".concat(_this14.creditNoteId, "/pdf/packing-list"), "get", null, true, "api", null, _this.exportingPdf.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.exportingPdf.isPending = false;
                          errorData = getErrorData(e, {}, "Unable to get PDF.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee9);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 6:
              response = _context10.sent;
              url = response.data.value.url;
              _this14.openUrl(url);
              _this14.exportingPdf.isPending = false;
            case 10:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    openUrl: function openUrl(url) {
      window.open(url, "_blank");
    },
    getCurrentRate: getCurrentRate,
    getSymbolCurrency: getSymbolCurrency,
    displayPrice: displayPrice,
    getUnitPriceCurrencyForItem: getUnitPriceCurrencyForItem
  }
};